import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VstxSvg = function VstxSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M20.5 20.25a.75.75 0 0 1-.75.75H8v.75a.25.25 0 0 0 .25.25h13a.25.25 0 0 0 .25-.25v-18h.25V3.5l-1.5-1v1.75h.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M6.75 20.5h13a.25.25 0 0 0 .25-.25v-16H6.5v16a.25.25 0 0 0 .25.25"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#605E5C",
      d: "M21.5 3.75v18a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V21h11.75a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25v-16H6v16a.75.75 0 0 0 .75.75h.75v.75a.75.75 0 0 0 .75.75h13a.75.75 0 0 0 .75-.75v-18z",
      opacity: 0.64
    }), /*#__PURE__*/_jsx("path", {
      fill: "#185ABD",
      d: "M12 7.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M7.2 14.035q.264.765.3.965c.035-.13.145-.475.34-1l1.405-4H10.5l-2.335 6H6.81L4.5 10h1.29z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#41A5EE",
      d: "M20.5 1.55a.5.5 0 0 0-.205-.05H6.5A.5.5 0 0 0 6 2v2l.25.25h14L20.5 4v-.625l.25-.25V2.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2B7CD3",
      d: "M6 4h14.5v.5H6zm14.925-.575L22 4.5V3.205a.5.5 0 0 0-.145-.35l-1.21-1.21a.5.5 0 0 0-.145-.095v2.055a.25.25 0 0 1 .425-.18"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#185ABD",
      d: "M17.25 13a.25.25 0 0 1-.25-.25v-2.5h-.5v2.5a.25.25 0 0 1-.25.25h-1v.5h2.5a.25.25 0 0 1 .25.25v1.5h.5v-1.5a.75.75 0 0 0-.75-.75z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#41A5EE",
      d: "M14 12h1.5v2.5H14z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#103F91",
      d: "m15.249 9.75 1.499-1.499 1.499 1.5-1.499 1.499z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2B7CD3",
      d: "M18.25 17.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
    })]
  });
};
export var Vstx = function Vstx(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: VstxSvg
  }));
};